// Helper functions for bridging the api/2 and api/3 quota API representations
// Should eventually become obsolete

function buildUsageByType(weights, currentMonth) {
  return {
    api: { calls: currentMonth?.api_count || 0, usage_per_call: weights.api },
    mcp: { calls: currentMonth?.mcp_count || 0, usage_per_call: weights.mcp },
    browser: { calls: currentMonth?.browser_count || 0, usage_per_call: weights.browser },
  };
}

function formatMonth(yyyyMm) {
  const [year, month] = yyyyMm.split('-');
  const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1);
  return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}

function buildMonthlyUsage(weights, months) {
  return months.map((m) => ({
    month: formatMonth(m.month),
    api: { calls: m.api_count, usage_per_call: weights.api },
    mcp: { calls: m.mcp_count, usage_per_call: weights.mcp },
    browser: { calls: m.browser_count, usage_per_call: weights.browser },
  }));
}

export async function fetchProjBillingQuotaData(fetcherObj, projectId, months = 6) {
  const [quotaResp, usageResp] = await Promise.all([
    fetcherObj.getProjectBillingQuota({ projectId }),
    fetcherObj.getProjectBillingUsageCounts({ projectId, months }),
  ]);

  const { weights } = quotaResp;
  const monthsData = usageResp.months || [];
  const currentMonth = monthsData.length ? monthsData[monthsData.length - 1] : null;

  return {
    quotaResp,
    usage: quotaResp.usage,
    weights,
    quotas: quotaResp.quotas,
    month_progress: quotaResp.month_progress,
    has_trial_expired: quotaResp.has_trial_expired,
    trial_expiry_date: quotaResp.trial_expiry_date,
    usage_by_type: buildUsageByType(weights, currentMonth),
    monthly_usage: buildMonthlyUsage(weights, monthsData),
  };
}

export async function fetchOrgBillingQuotaData(fetcherObj, orgId, months = 6) {
  const [quotaResp, usageResp] = await Promise.all([
    fetcherObj.getOrgBillingQuota({ orgId }),
    fetcherObj.getOrgBillingUsageCounts({ orgId, months }),
  ]);

  const { weights } = quotaResp;
  const monthsData = usageResp.months || [];
  const currentMonth = monthsData.length ? monthsData[monthsData.length - 1] : null;

  return {
    quotaResp,
    usage: quotaResp.usage,
    weights,
    quotas: quotaResp.quotas,
    month_progress: quotaResp.month_progress,
    has_trial_expired: quotaResp.has_trial_expired,
    trial_expiry_date: quotaResp.trial_expiry_date,
    usage_by_type: buildUsageByType(weights, currentMonth),
    monthly_usage: buildMonthlyUsage(weights, monthsData),
  };
}
